/**
 * Footballer Quiz flag: renders a nationality/league country as a CDN flag IMAGE (not an emoji — Android
 * can't draw subdivision flags like England/Scotland, which are all over the player pool). Reuses the same
 * name→code + flagcdn helpers the World Cup surfaces use. Renders nothing on an unknown country (graceful).
 */

import { memo, useMemo } from 'react';
import { Image } from 'expo-image';
import { footballerFlagStyles as styles } from './FootballerFlag.styles';
import { countryCodeFromName } from '../../../src/quiz/helpers/countryFlag.helper';
import { getFlagCdnUrl } from '../../../src/worldcup/helpers/flagCdn.helper';

interface FootballerFlagProps {
  country: string | null;
  width: number;
  height: number;
}

function FootballerFlagInner({ country, width, height }: FootballerFlagProps) {
  const uri = useMemo(() => {
    const code = country ? countryCodeFromName(country) : null;
    return code ? getFlagCdnUrl(code) : null;
  }, [country]);

  if (!uri) return null;
  return (
    <Image
      source={{ uri, cacheKey: uri }}
      style={[styles.image, { width, height }]}
      contentFit="cover"
      cachePolicy="memory-disk"
      accessibilityLabel={country ?? undefined}
    />
  );
}

export const FootballerFlag = memo(FootballerFlagInner);
